import styled from "@emotion/styled";

export const LabelField = styled("div")({
  fontWeight: "bold",
});
